export enum UserPermission {
  JourneyEventView = 'journey:event:view',
  ExternalContactsSessionView = 'externalContacts:session:view',
  ExternalContactView = 'externalContacts:contact:view',
  SmartAdvisorView = 'assistants:queue:view',

  ConversationCallAccept = 'conversation:call:accept',
  ConversationCallAdd = 'conversation:call:add',
  ConversationCallRecord = 'conversation:call:record',
  ConversationCallbackAccept = 'conversation:callback:accept',
  ConversationCallbackCreate = 'conversation:callback:create',

  ConversationCommunicationDisconnect = 'conversation:communication:disconnect',

  ConversationEmailAccept = 'conversation:email:accept',
  ConversationEmailCreate = 'conversation:email:create',

  ConversationWebMessagingAccept = 'conversation:webmessaging:accept',
  ConversationWebMessagingView = 'conversation:webmessaging:view',

  DirectoryUserView = 'directory:user:view',
  RoutingQueueSearch = 'routing:queue:search',

  UiDigitalDesktopView = 'ui:digitalDesktop:view',

  ConversationCobrowseAdd = 'conversation:cobrowse:add',

  IntegrationsIntegrationView = 'integrations:integration:view'
}
